/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
//ignore test commit
import { css } from 'lit';
export const SharedStyles = css `
  :host {
    display: block;
    box-sizing: border-box;
  }

  paper-card {
    --paper-card-header-color: var(--app-primary-color);
  }

  paper-item {
    border-color: var(--app-light-text-color);
    padding: 0px 0px;
  }

  paper-input {
    --paper-input-container: { padding: 0;}
  }

  section {
    padding: 24px;
    background-color: var(--app-section-odd-color);
  }

  section > * {
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
  }

  section:nth-of-type(even) {
    background: var(--app-section-even-color);
  }

  h2 {
    font-size: 24px;
    text-align: center;
    color: var(--app-dark-text-color);
  }

  @media (min-width: 460px) {
    h2 {
      font-size: 36px;
    }
  }

  .circle {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    text-align: center;
    border-radius: 50%;
    background: var(--app-primary-color);
    color: var(--app-light-text-color);
    font-size: 30px;
    line-height: 64px;
  }

  paper-tab {
    --paper-tab-ink: var(--app-primary-color);
  }

  paper-ripple {
    color: var(--app-primary-color);
  } 

  paper-tabs {
    --paper-tabs-selection-bar-color: var(--app-primary-color);
    height: 3rem;
  }

  section.navMenu {
    padding-top: 2px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  iron-icon:hover {
    fill: var(--app-primary-color);
  }

  #infobox {
    color: red;
  }
  .bws-tab {
    margin: 0;
    border-radius: 15px 15px 1px 1px;
  }
  .bws-tab h3 {
    color: white;
    background-color: var(--app-primary-color);
    margin: 0;
    font-size: 1.25em;
    padding: 4% 4%;
    border-radius: 15px 15px 1px 1px;
    width: 92%;
  }
  .bws-list {
    border-collapse: collapse;
    max-width: 100%;
    margin: auto;
    background-color: var(--app-section-even-color);
  }
  .bws-list:nth-child(even) {
    border-top: 1px solid #ddd;
  }
  .bws-list:hover {
    background-color: var(--app-primary-color);
  }
  .bws-list-body {
    border: solid 1px lightgray;
    max-width: 100%;
    margin: auto;
  }

  .bws-list-body > tr > td{
    border: solid 1px black;
    padding: 4px;
  }
  .bws-list-body:nth-child(even) {
    border: 1px solid #ddd;
    background-color: lightgray;

  }
  .bws-box {
    background-color: white;
    margin: .8em;
    padding: .6em .9em;
    border: .25px solid rgba(120, 144, 156,.2);
    border-radius: 5px;
    box-shadow: 2px 2px 2px darkgrey;
  }
  .import-list li:nth-child(even){
    background-color: var(--app-section-even-color);
  }
  .info-card {
    margin: 0em 2em;
  }
  .odd {
    background-color: rgba(120,144,156,.2);
  }
  .bws-header {
    color: white;
    background-color: var(--app-primary-color);
    margin: 0;
    padding: 2% 2%;
    border-radius: 15px 15px 1px 1px;
    width: 96%;
  }
  .blue-text {
    display: inline-block;
    font-weight: bold;
    color:var(--app-primary-color);
    padding-top: .2em;
  }
  @media (max-width: 700px) {
    paper-item {
      padding: 5px;
      margin-left: 0;
    }

    paper-item.button:hover {
      cursor: pointer;
    }
    
    .job-date-header-row {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 0.5em;
    }

    .job-date-row {
      flex-direction: column;
      align-items: flex-start;
    }

    .year-desktop {
      display: none !important;
    }
  }

  .statusBox {
  padding: 2px 5px;
  border-radius: 3px;
  color: darkgrey;
  }

  .status-error {
    background-color: #dc3545; /* Red */
  }

  .status-cancelled {
    background-color:rgba(220, 53, 70, 0.46); /* Dark Red */
  }

  .status-placed {
    background-color:rgb(173, 173, 173); /* Grey */
  }

  .status-preprocessing {
    background-color:rgb(255, 177, 104); /* Light Orange */
  }

  .status-waiting {
    background-color:rgb(255, 123, 0); /* Orange */
  }

  .status-ready {
    background-color:rgb(255, 255, 0); /* Yellow */
  }
  
  .status-processing {
    background-color:rgb(0, 255, 0); /* Green */
  }

  .status-processed {
    background-color:rgb(0, 85, 0); /* Dark Green */
  }

  .status-rendered {
    background-color:rgb(0, 0, 255); /* Blue */
  }

  .status-printed {
    background-color:rgba(0, 0, 255, 0.25); /* Dark Blue */
  }

  .status-shipped {
    background-color:rgb(224, 129, 253); /* Light Purple */
  }

  .status-completed {
    background-color:rgb(195, 0, 255); /* Purple */
  }

  .status-archived {
    background-color:rgba(195, 0, 255, 0.34); /* Dark Purple */
  }

  .status-unknown {
    background-color:rgb(255, 0, 200); /* Pink */
  }

  ref-viewer.field {
    color: blue;
  }
  .job-date-header-row {
    display: flex;
    justify-content: space-between;
  }

  .job-date-row {
    color: var(--app-primary-color);
    display: flex;
    justify-content: space-between;
  }

  .shared-popup-content {
    max-width: 500px !important;
    max-height: 90vh !important;
    margin: auto !important;
    background: white;
    border-radius: 12px;
    box-shadow: 0 12px 48px rgba(0,0,0,0.4);
    padding: 0;
    width: auto !important;
  }
  .popup-container {
    position: relative;
    padding: 40px 24px 24px 24px;
    width: 450px;
    box-sizing: border-box;
  }
  @media (max-width: 450px) {
    .shared-popup-content {
      display: none;
    }
    .popup-container {
      width: 100vw;
      padding: 20px 0 0 0;
    }
    .mobile-popup-contact-card {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      overflow: auto;
      box-sizing: border-box;
    }
  }
  .section-block {
    margin: 18px 0 18px 0;
    border: none;
    background: none;
    padding: 0;
    border-bottom: 1px solid #e0e0e0;
    width: calc(100% - 32px);
    margin-left: 16px;
  }
  .section-block:last-child {
    border-bottom: none;
  }
  .section-block h6 {
    margin-top: 0;
    margin-bottom: 8px;
    font-weight: 600;
    color: #1976d2;
    background: none;
    padding-left: 0;
    border-left: none;
  }
`;
